import React, { useCallback, useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { alertMessages } from 'src/constants';
import '../stationSearch/SearchWeatherStation.scss';
import { useAddAlert } from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import Graphic from '@arcgis/core/Graphic';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import moment from 'moment';
import { getSiteByKey, getSiteKeysForSearch } from 'src/apis/getFuelSampleCalls';
import { errorResponse } from 'src/store/common';

interface SearchSiteProps {
    view: any,
}

const SearchSite: React.FC<SearchSiteProps> = ({
    view, 
  }) =>{
    const [state,dispatch] = useStoreContext();
	  const addAlert = useAddAlert(dispatch);

    const [searchSiteKeys, setSearchSiteKeys] = useState<any[]>([]);
    const [searchedSite, setSearchedSite] = useState<any>(null);
    
    const handleSearch=(e:React.SyntheticEvent<Element, Event>, val: any)=>{
		if(val!== null && typeof val!=='undefined'){
            (async()=>{
                try{
                  const siteInfo:any = await getSiteByKey(null,val?.site_id);
                  if(siteInfo.length===1){
                    const siteSearch:any = {...siteInfo[0]} 

                    setSearchedSite(siteSearch)
                    view.goTo({
                      center: [Number(siteSearch.longitude), Number(siteSearch.latitude)],
                      zoom: 12
                    })

                  }
                }
                catch(error){
                  errorResponse(error, addAlert, alertMessages.fieldSampleHomeData)
                }
              })();
		}
        else{
            setSearchedSite(null)
        }
	}
    /*gets the highlightsymbol*/
    const getHighlightSymbol = (layerId: string)=>{
        let symbol: any;
        if(layerId.includes('fieldSample')){
          symbol={
            type: 'simple-marker',
            style: 'circle',
            color:[255, 222, 33, 0.75],
            size:'30px',
            outline:{
                color: [255, 222, 33],
                width: 2
            }
          }
        }
        return symbol
      }


    /*highlight after search, needs a layer and id*/
    const addHighlight = useCallback((layer:any, id:string)=>{
        const query = layer.createQuery();
        query.where =`id = '${searchedSite.siteId}'`;
        layer.queryFeatures(query).then((result)=>{
            if(result.features.length>0){
                const highlightSymbol= new Graphic({
                    geometry: result.features[0].geometry,
                    symbol: getHighlightSymbol(result.features[0].layer.id)
                });
                let highlightLayer = new GraphicsLayer({id:id});
                highlightLayer.add(highlightSymbol);
                view.map.add(highlightLayer);
                view.map.reorder(highlightLayer, view.map.layers.length-1);
            }
        })
    } ,[view.map, searchedSite?.siteId, ])
      /* items in the useEffect will highlight after search*/
    useEffect(()=>{
        if(view.map?.layers && searchedSite!==null){
            //need a listener to see when layers has changed
            const listener = view.map.layers.on('change',(event)=>[
                event.added.forEach((layer)=>{
                    if(layer.id.includes('&Zoom=5') 
                      && layer.id.includes('fieldSample') 
                      && layer.id.includes(`&StartDate=${moment(state.fsMapStartDate).utc().format('YYYY-MM-DD')}`)
                      && layer.id.includes(`&EndDate=${moment(state.fsMapEndDate).utc().format('YYYY-MM-DD')}`)
                    ){
                        const stringFS = `highlightLayer-${searchedSite.siteId}-${state.fsMapFuel? state.fsMapEndDate.fuel_type: null}-${moment(state.fsMapStartDate).utc().format('YYYY-MM-DD')}-${moment(state.fsMapEndDate).utc().format('YYYY-MM-DD')}-${state.fsMapMethod.code_key==='None'? null: state.fsMapMethod.code_key}-${state.fsMapSubCat.code_key ==='None'? null: state.fsMapSubCat.code_key}`;
                        addHighlight(layer, stringFS)
                    }
                })
            ]);

            view.map.layers?.forEach((layer)=>{
              if(layer.id.includes('&Zoom=5') 
                && layer.id.includes('fieldSample') 
                && layer.id.includes(`&StartDate=${moment(state.fsMapStartDate).utc().format('YYYY-MM-DD')}`)
                && layer.id.includes(`&EndDate=${moment(state.fsMapEndDate).utc().format('YYYY-MM-DD')}`)
              ){                
                const stringFS = `highlightLayer-${searchedSite.siteId}-${state.fsMapFuel? state.fsMapEndDate.fuel_type: null}-${moment(state.fsMapStartDate).utc().format('YYYY-MM-DD')}-${moment(state.fsMapEndDate).utc().format('YYYY-MM-DD')}-${state.fsMapMethod.code_key==='None'? null: state.fsMapMethod.code_key}-${state.fsMapSubCat.code_key ==='None'? null: state.fsMapSubCat.code_key}`;
                addHighlight(layer, stringFS)
              }
            })
            return()=>{
                listener.remove();
            }

        }
    },[view.map.layers, searchedSite, view.graphics, view.map, addHighlight, state.fsMapEndDate, state.fsMapFuel, state.fsMapSubCat, state.fsMapStartDate, state.fsMapMethod])

    useEffect(()=>{
        //below removes layer
        if( view.map?.layers){
            let uniqueIdCount = 0;
            view.map.layers?.forEach((layer)=>{
                if(layer.id.includes('highlightLayer')){
                    if(searchedSite){
                        if(layer.id !== (`highlightLayer-${searchedSite.siteId}-${state.fsMapFuel? state.fsMapEndDate.fuel_type: null}-${moment(state.fsMapStartDate).utc().format('YYYY-MM-DD')}-${moment(state.fsMapEndDate).utc().format('YYYY-MM-DD')}-${state.fsMapMethod.code_key==='None'? null: state.fsMapMethod.code_key}-${state.fsMapSubCat.code_key ==='None'? null: state.fsMapSubCat.code_key}`)){
                            view.map.remove(layer);
                        }
                        else{
                            uniqueIdCount= uniqueIdCount+1;
                            if(uniqueIdCount>1){
                                view.map.remove(layer);
                            }
                        }
                    }
                    else{
                        view.map.remove(layer);
                    }
                }

            })
        }
    },[searchedSite, view.map,state.fsMapEndDate, state.fsMapFuel, state.fsMapSubCat, state.fsMapStartDate, state.fsMapMethod])

    const siteCallback = useCallback(() =>{
      (async()=>{
        try{
          const siteKeys:any = await getSiteKeysForSearch(null, addAlert);
          setSearchSiteKeys(siteKeys);

        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
        }
      })();
	},[addAlert, ]);
	

    useEffect(()=>{
        if(searchSiteKeys.length<1){
            siteCallback();
        }
    },[siteCallback, searchSiteKeys.length]);

  useEffect(() => {
  }, [state.alerts]);

    return(
        <div className={state.alerts?.filter((a)=>a.type==='warning')?.length>0?'searchStationsContainer-warning-present':'searchStationsContainer-closed'}>
            <i className="fas fa-search" style={{ paddingLeft: '5px' }} />
            <Autocomplete
                  freeSolo
                  onChange={(e, value) =>handleSearch(e,value)}
                  options={searchSiteKeys.map((option, index) => ({
                    ...option,
                    uniqueKey: `${option.site_key}-${index}`
                  }))}
                  getOptionLabel={(option) => option.display_key}
                  filterOptions={(options, state)=>{
                    const inputValue = state.inputValue.trim().toLowerCase().split(/[ -]+/);
                    const filtered = options.filter((option)=>{
                      const optionWords = option.site_key.toLowerCase().split(/[ -]+/)

                      return inputValue.every((word)=>{
                        return optionWords.some((optionWord)=> optionWord.startsWith(word))
                      })
                    })
                    return filtered
                  }}
                  renderInput={(params) => (
                    <TextField
                      data-testid={'search-all-sites'}
                      {...params}
                      label="Search All Sites..."
                      InputProps={{
                        ...params.InputProps,
                        type: 'search',
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.uniqueKey}>
                      {option.display_key}
                    </li>
                  )}
                />
        </div>
    )
}

export default SearchSite;
